module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-alert-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "el-alert",
    class: [_vm.typeClass]
  }, [(_vm.showIcon) ? _c('i', {
    staticClass: "el-alert-icon",
    class: [_vm.iconClass, _vm.isBigIcon]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "el-alert-content"
  }, [(_vm.title) ? _c('span', {
    staticClass: "el-alert-title",
    class: [_vm.isBoldTitle]
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.description) ? _c('p', {
    staticClass: "el-alert-description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.closable),
      expression: "closable"
    }],
    staticClass: "el-alert-closebtn",
    class: {
      'is-customed': _vm.closeText !== '', 'el-icon-close': _vm.closeText === ''
    },
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.closeText))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0933c7d2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/alert/src/alert.vue
// module id = 602
// module chunks = 0